module.exports = __webpack_public_path__ + "img/scanner.12c9edd2.jpg";